import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Col, Glyphicon, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import StepZilla from 'react-stepzilla';
import { userTourDone } from '../../actions/userActions';
import SignUpForm from '../SignUpForm';
import { isDemoAccount } from './../../helpers/utils';
import Button from './Button';
import ConfirmDialog from './ConfirmDialog';
import RegisterSmsPhoneForm from './RegisterSmsPhoneForm';


class AccountVerificationStep extends PureComponent {
    render() {
        return (
            <div className="step">
            <p>Tell us more about yourself:</p>
            <br />
            <SignUpForm personalInformationOnly={enabled => {
                this.props.nextEnabled(enabled);
                this.props.jumpToStep(1);
            }} />
            </div>
        );
    }
}


class EmailStep extends PureComponent {
    render() {
        return (
            <div className="step">
            <p>Connect your email and calendar provider to send emails and sync view tasks in your calendar:</p>
            <br />
            <SignUpForm renderEmailIntegrationOnly />
            </div>
        );
    }
}


class SmsStep extends PureComponent {
    render() {
        return (
            <div className="step">
            <p>Create your virtual SMS number to communicate with your clients over SMS:</p>
            <br />
            <RegisterSmsPhoneForm />
            <br />
            </div>
        );
    }
}


class PaymentStep extends PureComponent {
    render() {
        return (
            <div className="step">
            <p>Connect with LawPay / PayPal in order to automate collecting payments from your clients:
            <br />
            </p>
            <SignUpForm renderPaymentIntegrationOnly />
            <br /><br />
            </div>
        );
    }
}


class FormEditorStep extends PureComponent {
    render() {
        return (
            <div className="step">
            <p>Customize your case type intake form. These are the forms you use to create new cases.
            They can vary based on the case type. For example, a DUI would be different than Personal Injury. 
            Customize this to fit your practice. Contact us via Help -{'>'} Feedback if you need assistance.</p>
            <Row>
            <Col xs={4}>
            <Button onClick={this.props.editCaseForms}
                    label="Update Case Type Forms"
            />
            </Col>
            </Row>    
            <br/>
            </div>
        );
    }
}


class CaseStatesStep extends PureComponent {
    render() {
        return (
            <div className="step">
            <p>Case state is describing a life stages of all case types. You can tag each case with a state to know where in your pipeline given case currently is. Suggested pipeline would like something like this:</p>
            <br/>
            <ol>
                <li>- <b>Lead</b> - potential client filled in form on your website</li>
                <li>- <b>Awaiting Payment and Signature</b> - you have emailed them an offer along with client portal where they can pay and sign</li>
                <li>- <b>Preparing Initial Docs</b> - client has paid and signed your agreement and now you have to prepare initial case documentation (ideally using document automation, see next steps)</li>
                <li>- <b>Awaiting Court Date</b> - waiting for court date</li>
                <li>- <b>Trial Processing</b> - case being processed</li>
                <li>- <b>Decided</b> - case has been resolved with certain decision</li>
            </ol>
            <br />
            <p>
            If this doesn't work for the cases you deal with, customize the states here:
            </p>
            <Row>
            <Col xs={4}>
                <Button onClick={this.props.editCaseStates}
                        label="Case States"
                />
            </Col>
            </Row>
            <br />
            </div>
        );
    }
}


class PlaceholdersStep extends PureComponent {
    render() {
        return (
            <div className="step">
            <p>Every field you have created in the previous step has a so called placeholder, that you can you when creating email or document templates. An example of placeholder would be: <br /><br />
            <code>{'{'}client.FirstName{'}'}</code><br /><br />
            Depending on the opened case, the proper information (clients first name in this case) will be copied instead of the placeholder when email gets sent / document gets generated.
            <br />
            List of all placeholders can be found: <span>[<Glyphicon glyph="question-sign" /> Help -{'>'} Template Placeholders]</span>
            </p>
            </div>
        );
    }
}


class WelcomeDialog extends PureComponent {
    constructor(props) {
        super(props);
        this.finish = this.finish.bind(this);
        this.state = {
            stepIndex: 0,
            nextEnabled: false,
        };
    }

    finish() {
        this.props.dispatch(userTourDone('welcomeTourDone'));
    }

    render() {
        const { loggedIn } = this.props;
        // Demo accounts never see onboarding — they land in a populated app.
        if (!loggedIn || loggedIn.welcomeTourDone || isDemoAccount(loggedIn)) {
            return <div />;
        }

        const steps = [
            { name: 'About You', component: 
                <AccountVerificationStep nextEnabled={enabled => this.setState({ nextEnabled: enabled })} /> },
            { name: 'Email', component: <EmailStep accountName={this.props.loggedIn && this.props.loggedIn['FirstName']} /> },
            { name: 'SMS', component: <SmsStep accountName={this.props.loggedIn && this.props.loggedIn['FirstName']} /> },
            { name: 'Payment', component: <PaymentStep accountName={this.props.loggedIn && this.props.loggedIn['FirstName']} /> },
            { name: 'Case Type Forms', component: <FormEditorStep editCaseForms={this.props.editCaseForms} editContactForms={this.props.editContactForms} /> },
            { name: 'Case States', component: <CaseStatesStep editCaseStates={this.props.editCaseStates} /> },
        ];

        if (!this.props.isOwner) {
            steps.splice(2, 2);
        }
       
        return (
            <ConfirmDialog title="Welcome to Case Tempo!"
                           open
                           size="welcome"
                           confirm={this.state.stepIndex === steps.length - 1 && this.finish}
                           confirmLabel="Done"
            >
            <Row>
            <div className="step-progress" style={{ margin: 15 }}>
                <StepZilla steps={steps}
                           onStepChange={(step) => { this.setState({ stepIndex: step }); }}
                           backButtonCls="btn btn-prev btn-secondary pull-left"
                           nextButtonCls="btn btn-next btn-secondary pull-right"
                           showNavigation={this.state.stepIndex > 0}
                           stepsNavigation={this.state.nextEnabled}
                />
            </div>
            </Row>
            </ConfirmDialog>
        );
    }
}

WelcomeDialog.propTypes = {
    editCaseForms: PropTypes.func.isRequired,
    editContactForms: PropTypes.func.isRequired,
    editCaseStates: PropTypes.func.isRequired,
    editCaseTypeTasks: PropTypes.func.isRequired,
    editEmailTemplates: PropTypes.func.isRequired,
    editDocumentTemplates: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    const loggedIn = state.user.loggedIn;
    const isOwner = loggedIn.owner_id === 0;
    return {
        loggedIn,
        isOwner,
    };
};

export default connect(mapStateToProps)(WelcomeDialog);
